<template>
  <UnbatchedReport v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { Filter } from "@/components/DatatableV3.vue";
import UnbatchedReport from "./UnbatchedReport.vue";

const initialData = ref<{
  invoicesSource: string;
  paymentsSource: string;
  invoiceFilters: Filter[];
  paymentFilters: Filter[];
  globalFilters: Filter[];
  initialBatchName: string;
} | null>(null);

onMounted(async () => {
  // Load initial page data and send to component as props
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>

<style scoped></style>
